import React, { useContext, useEffect, useState } from "react";

import { userAccessService } from "../../../Restclient/datacollection";
import {
  Box,
  TableContainer,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@mui/material";
import DeleteIcon from "../../../images/LK_Delete";
import EditIcon from "../../../images/LK_Edit";
import EyeOpenIcon from "../../../images/LK_Eye_Open.png";
import AddIcon from "../../../images/LK_Add";
import UserDetailsView from "./UserDetailsView";
import { useSelector } from "react-redux";
import { Tooltip } from "@mui/material";
import { ThemeContext } from "../../Homepage";
import Spinner from "../AdminDashboard/Spinner";
import CustomDialogBox from "../../CommonComponents/CustomDialogBox";

const RoleAccessManagement = ({ selectedTreeNode, isReadOnly = false }) => {
  const node = JSON.parse(JSON.stringify(selectedTreeNode));
  const userdetails = useSelector((state) => state.logindata.userdetails);
  const { User_Role_ID, Organizationid, Projectlist } = useSelector(
    (state) => state.logindata.userdetails
  );
  const [usersLst, setUsersLst] = useState([]);
  const [rolesLst, setRolesLst] = useState([]);
   const [allRoles, setAllRoles] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [dialogAction, setDialogAction] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const { theme } = useContext(ThemeContext);
  const [isLoading, setIsLoading] = useState(false);
  const [allRolesLst, setAllRolesLst] = useState([]);
  const mCode = "USCR06";
  const { PermissionsArray: usrPrmns } = useSelector(
    (state) => state.logindata.userdetails
  );
  const [alertState, setAlertState] = useState({
    show: false,
    message: "",
    type: "success", 
  });

   let OrgID = (selectedTreeNode?.Type === "sub-organization" || selectedTreeNode?.Type === "organization") ? selectedTreeNode?.Organizationid : (selectedTreeNode?.Type === "Project") ? selectedTreeNode.Organizationid :"All";
   let ProID = (selectedTreeNode?.Type === "sub-organization" || selectedTreeNode?.Type === "organization") ? "All" : (selectedTreeNode?.Type === "Project") ? selectedTreeNode.ProjectId :"All";


  const fetchUsers = async () => {
    try {
      let data = [];
      setIsLoading(true);

      // Guard clause: check node and node.Type before accessing properties
      if (!node || !node.Type) {
        setUsersLst([]);
        setIsLoading(false);
        return;
      }

      const type = node.Type.toLowerCase();
      if (type === "project") {
        data = await userAccessService.getUsersByProject(node?.ProjectId);
      } else if (type === "organization" || type === "sub-organization") {
        data = await userAccessService.getUsersByOrg(node?.Organizationid);
      }
      setUsersLst(data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
    setIsLoading(false);
  };
  const fetchUsersRoles = async () => {
    try {
      setIsLoading(true);
      let projectID =
        userdetails?.User_Role_Details?.Name == "EA_ADMIN" ||
        userdetails?.User_Role_Details?.Name == "ORGANIZATION_ADMIN"
          ? "All"
          : userdetails?.Projectlist[0];
      let organizationID =
        userdetails?.User_Role_Details?.Name == "EA_ADMIN"
          ? "All"
          : Organizationid;
      let userRoleID = User_Role_ID;

      const roles = await userAccessService.getRolesByUserDetails(
        ProID,
        OrgID,
        userRoleID
      );
      setRolesLst(roles.data);

      const allRoles = await userAccessService.getAllRolesByUserDetails(
            ProID,
            OrgID,User_Role_ID);
      setAllRoles(allRoles.data);

    } catch (err) {
      console.error("Error fetching roles:", err);
      setIsLoading(false);
    }
  };

       const isEAAdmin = userdetails?.User_Role_Details?.Name === "EA_ADMIN";
      const isOrgAdmin = userdetails?.User_Role_Details?.Name === "ORGANIZATION_ADMIN";
      const projectId = (isEAAdmin || isOrgAdmin) ? "All" : userdetails?.Projectlist[0];
      const orgId = isEAAdmin ? "All" : Organizationid;

  const fetchAllUserRoles = async () => {
    try {
      setIsLoading(true);
      const allRoles = await userAccessService.getAllRolesByUserDetails(ProID,OrgID, User_Role_ID);
      setAllRolesLst(allRoles.data);
    } catch (err) {
      console.error("Error fetching all user roles:", err);
    }
    setIsLoading(false);
  }

  useEffect(() => {
    fetchUsers();
    fetchUsersRoles();
    fetchAllUserRoles();
  }, [node?.Organizationid, node?.ProjectID, selectedUser, selectedTreeNode]);

  const openDialog = (action, user = null) => {
    setDialogAction(action);
    setSelectedUser(user);
    setDialogOpen(true);
  };

  const handleSaveUser = async (userData) => {
    try {
      if (!node) {

        setAlertState({
        show: true,
        message: "No organization or project selected.",
        type: "Warning",
        confirmText:"OK"
      });

        // alert("No organization or project selected.");

        
        return;
      }

      // Add organization/project details to userData
      userData = {
        ...userData,
        organizationID: node?.Organizationid,
        groupID: "",
      };

      if (
        dialogAction === "add" &&
        node.Type &&
        node.Type.toLowerCase() === "project"
      ) {
        const projects = userData.projectIDArray || [];
        if (node.ProjectId) {
          const existingProject = projects.find( (project) => project === node.ProjectId);
          if (!existingProject) {
          projects.push(node.ProjectId);
          }
        }
        userData = { ...userData, projectIDArray: projects };
      }

      if (dialogAction === "add") {
        const userObj = {
          userCreaterProjectID:
            userdetails?.User_Role_Details?.Name == "EA_ADMIN" ||
            userdetails?.User_Role_Details?.Name == "ORGANIZATION_ADMIN"
              ? "All"
              : userdetails?.Projectlist[0],
          userCreatorOrganizationID:
            userdetails?.User_Role_Details?.Name == "EA_ADMIN"
              ? "All"
              : Organizationid,
          userCreaterRoleID: User_Role_ID,
          userobject: userData,
          NodeType:node.Type.toLowerCase()
        };
        const {
          success,
          data: newUser,
          message,
        } = await userAccessService.addUser(userObj);
        if (success) {
          setUsersLst(newUser);
            setAlertState({
            show: true,
            message: message || "User added successfully!",
            type: "Info",
            confirmText:"OK"
          });
         
        } else {
          // alert(message || "Failed to add user.");
           setAlertState({
            show: true,
            message: message || "User added successfully!",
            type: "Error",
            confirmText:"OK"
          });
        }
      } else if (dialogAction === "edit") {
        const userObj = {
          userUpdaterProjectID:
            userdetails?.User_Role_Details?.Name == "EA_ADMIN" ||
            userdetails?.User_Role_Details?.Name == "ORGANIZATION_ADMIN"
              ? "All"
              : userdetails?.Projectlist[0],
          userUpdaterOrganizationID:
            userdetails?.User_Role_Details?.Name == "EA_ADMIN"
              ? "All"
              : Organizationid,
          userUpdaterRoleID: User_Role_ID,
          userobject: userData,
          NodeType:node.Type.toLowerCase()
        };

        const {
          success,
          data: updatedUser,
          message,
        } = await userAccessService.updateUser(userObj);
        if (success) {
          setUsersLst(updatedUser);
          // alert();
             setAlertState({
            show: true,
            message:message || "User updated successfully!",
            type: "Info",
            confirmText:"OK"
          });
        } else {
          // alert(message || "Failed to update user.");
              setAlertState({
            show: true,
            message: message || "Failed to update user.",
            type: "Error",
            confirmText:"OK"
          })
        }
      }
    } catch (error) {
      
        setAlertState({
            show: true,
            message: "An error occurred while saving the user. Please try again.",
            type: "Error",
            confirmText:"OK"
          })

      // alert("An error occurred while saving the user. Please try again.");
    }
  };

  const handleDeleteUser = async (userID) => {
    try {
      const userDetails = usersLst.find((user) => user.userID === userID);
      const userObj = {
        userDeleterProjectID:
          userdetails?.User_Role_Details?.Name == "EA_ADMIN" ||
          userdetails?.User_Role_Details?.Name == "ORGANIZATION_ADMIN"
            ? "All"
            : userdetails?.Projectlist[0],
        userDeleterOrganizationID:
          userdetails?.User_Role_Details?.Name == "EA_ADMIN"
            ? "All"
            : Organizationid,
        userDeleterRoleID: User_Role_ID,
        userobject: userDetails,
        NodeType:node.Type.toLowerCase()
      };

      const { success, message, data } = await userAccessService.deleteUser(userObj);
      if (success) {
        setUsersLst(data);
        // alert();
          setAlertState({
            show: true,
            message: message || "User deleted successfully!",
            type: "Info",
            confirmText:"OK"
          });
      } else {
        // alert(message || "Failed to delete user.");
          setAlertState({
            show: true,
            message: message || "Failed to delete user.",
            type: "Warning",
            confirmText:"OK"
          })
      }
    } catch (error) {
      // alert("An error occurred while deleting the user. Please try again.");
     setAlertState({
            show: true,
            message: "An error occurred while deleting the user. Please try again.",
            type: "Warning",
            confirmText:"OK"
          })
    }
  };

  const filteredUsers = Array.isArray(usersLst)
    ? usersLst.filter((user) =>
        user?.email?.toLowerCase()?.includes(searchQuery?.toLowerCase())
      )
    : [];

  const getRoleName = (id) => {
    const item = allRoles?.find((role) => role?.UserRoleID === id);
    return item && `${item.RoleLevel} (${item.Name})`;
  };

  const updateUserProjects = async (userData, Projectlist) => {
    const userObj = {
      userUpdaterProjectID:
        userdetails?.User_Role_Details?.Name == "EA_ADMIN" ||
        userdetails?.User_Role_Details?.Name == "ORGANIZATION_ADMIN"
          ? "All"
          : userdetails?.Projectlist[0],
      userUpdaterOrganizationID:
        userdetails?.User_Role_Details?.Name == "EA_ADMIN"
          ? "All"
          : Organizationid,
      userUpdaterRoleID: User_Role_ID,
      userobject: userData,
      NodeType: node.Type.toLowerCase()
    };

    const {
      success,
      data: updatedUser,
      message,
    } = await userAccessService.updateUser(userObj);
    if (success) {
      // Refresh users list to trigger re-render
      await fetchUsers();
      setAlertState({
        show: true,
        message: message || "User projects updated successfully!",
        type: "Info",
        confirmText: "OK"
      });
    } else {
      setAlertState({
        show: true,
        message: message || "Failed to update user projects.",
        type: "Error",
        confirmText: "OK"
      });
    }
  };

  const lstHeading = ["User Name", "Email", "Role", "Mobile", "Actions"];
  const lstHeadingStyle = {
    backgroundColor: theme === "dark" ? "#252525" : "#F0EFEF",
    color: theme === "dark" ? "#C1C1C1" : "#3A4452",
    fontFamily: "Roboto",
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "19px",
    textAlign: "left",
  };
  const getLstHeader = (headings) => {
    return headings.map((item) => (
      <TableCell style={lstHeadingStyle}>{item}</TableCell>
    ));
  };

  return (
    <>
      {/* <div>Role Access Management</div>
      <div>
        Organization name:{node?.Organizationname}
        <br />
        Organization ID:{node?.Organizationid}
        <br /> */}
      {/* </div> */}
      {isLoading && <Spinner size="40px" color="blue" speed="0.8s" />}
      <Box
        style={{
          backgroundColor: theme === "dark" ? "#252525" : "#F0EFEF",
          // padding: "5px",
          marginTop: "10px",
          color: theme === "dark" ? "#C1C1C1" : "#3A4452",
        }}
      >
        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "5px 10px",
            backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
            color: theme === "dark" ? "#C1C1C1" : "#3A4452",
          }}
        >
          <Typography
            variant="subtitle1"
            sx={{
              color: "#008CD7",
              fontWeight: "bold",

              // backgroundColor: theme === "dark" ? "#252525" : "#F0EFEF",
            }}
          >
            Users List
          </Typography>
          <Box>
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{
                width: "350px",
                height: "40px",
                backgroundColor: theme === "dark" ? "#252525" : "#F0EFEF",
                color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
                border: "none",
                borderBottom: "1px solid #008CD7",
                padding: "0px 5px",
                marginRight: "20px",
                outline: "none",
              }}
            />
            <Button
              style={{
                width: "125px",
                height: "35px",
                fontSize: "18px",
                backgroundColor: isReadOnly ? "#CCCCCC" : "rgb(0, 92, 142)",
                color: "rgb(255, 255, 255)",
                cursor: isReadOnly ? "not-allowed" : "pointer",
                border: "none",
                borderRadius: "25px",
                textTransform: "none",
              }}
              onClick={() => !isReadOnly && openDialog("add")}
              disabled={isReadOnly}
            >
              Add
            </Button>
          </Box>
        </Box>

        {usrPrmns && usrPrmns.includes(mCode) && (
          <TableContainer
            component={Paper}
            style={{
              maxHeight: "600px",
              // overflowY: "scroll",
              // backgroundColor: theme === "dark" ? "#252525" : "#F0EFEF",
              color: theme === "dark" ? "#C1C1C1" : "#3A4452",
              boxShadow: "none",
              background: "#f0efef",
              // marginTop: "20px",
            }}
          >
            <Table stickyHeader>
              <TableHead
                style={{
                  backgroundColor: theme === "dark" ? "#252525" : "#F0EFEF",
                  color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                }}
              >
                <TableRow
                  sx={{
                    backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                  }}
                >
                  {getLstHeader(lstHeading)}
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredUsers.length > 0 ? (
                  filteredUsers.map((user) => (
                    <TableRow
                      sx={{
                        backgroundColor:
                          theme === "dark" ? "#252525" : "#F0EFEF",
                        color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                      }}
                      key={user.userID}
                    >
                      <TableCell
                        sx={{
                          backgroundColor:
                            theme === "dark" ? "#252525" : "#F0EFEF",
                          color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                        }}
                      >
                        {user.userName}
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor:
                            theme === "dark" ? "#252525" : "#F0EFEF",
                          color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                        }}
                      >
                        {user.email}
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor:
                            theme === "dark" ? "#252525" : "#F0EFEF",
                          color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                        }}
                      >
                       {
                        (() => {
                          const roleName = getRoleName(user.userRoleID);
                          return roleName
                            ? roleName.charAt(0).toUpperCase() + roleName.slice(1).toLowerCase()
                            : "";
                        })()
                      }
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor:
                            theme === "dark" ? "#252525" : "#F0EFEF",
                          color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                        }}
                      >
                        + {user.countryCode + " "}
                        {user.mobile || "N/A"}
                      </TableCell>
                      <TableCell>
                        {user?.userRolesObject?.Name=="ORG_ANALYST" && (<Tooltip title="Assign Project" arrow>
                          <span
                            onClick={() => openDialog("assignProject", user)}
                            style={{
                              marginRight: "2px",
                              padding: "4px",
                              cursor: "pointer",
                            }}
                          >
                            <img
                              src={EyeOpenIcon}
                              style={{
                                width: "20px",
                                height: "20px",
                                paddingTop: "4px",
                                marginRight: "4px",
                              }}
                              alt="Assign Project"
                            />
                          </span>
                        </Tooltip>)}
                        <Tooltip title="View" arrow>
                          <span
                            onClick={() => openDialog("view", user)}
                            style={{
                              marginRight: "2px",
                              padding: "4px",
                              cursor: "pointer",
                            }}
                          >
                            <img
                              src={EyeOpenIcon}
                              style={{
                                width: "20px",
                                height: "20px",
                                paddingTop: "4px",
                                marginRight: "4px",
                              }}
                              alt="View"
                            />
                          </span>
                        </Tooltip>
                        {!isReadOnly && (
                          <>
                            <Tooltip title="Edit" arrow>
                              <span
                                onClick={() => openDialog("edit", user)}
                                style={{
                                  marginRight: "2px",
                                  padding: "4px",
                                  cursor: "pointer",
                                }}
                              >
                                <EditIcon
                                  color="var(--LK_BrandBlue)"
                                  width={"18px"}
                                  height={"18px"}
                                />
                              </span>
                            </Tooltip>
                            <Tooltip title="Delete" arrow>
                              <span
                                onClick={() => openDialog("delete", user)}
                                style={{
                                  marginRight: "2px",
                                  padding: "4px",
                                  cursor: "pointer",
                                }}
                              >
                                <DeleteIcon
                                  color="var(--LK_BrandBlue)"
                                  width={"18px"}
                                  height={"18px"}
                                />
                              </span>
                            </Tooltip>
                          </>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={5}
                      align="center"
                      sx={{
                        backgroundColor:
                          theme === "dark" ? "#252525" : "#F0EFEF",
                        color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                      }}
                    >
                      <Typography>No matching users found.</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        <UserDetailsView
          open={dialogOpen}
          actionType={dialogAction}
          user={selectedUser}
          onClose={() => setDialogOpen(false)}
          onSave={handleSaveUser}
          onDeleteConfirm={handleDeleteUser}
          rolesLst={rolesLst}
          userRoleName={getRoleName(selectedUser?.userRoleID)}
          updateUserProjects={updateUserProjects}
          nodeUsed={node.Type}
        />
      </Box>
      <CustomDialogBox
  dialogTitle={alertState.message}
  openDialog={alertState.show}
  handleConfirmDialog={() => setAlertState((prev) => ({ ...prev, show: false }))}
  confirmText={alertState.confirmText || "OK"}
  type={alertState.type}
/>
    </>
  );
};

export default RoleAccessManagement;
